export const Formats: FormatList = [

	{
		section: "Cobblemon",
	},
	{
		name: "Cobblemon Singles",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "singles"
	},
	{
		name: "Cobblemon Doubles",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "doubles"
	},
	{
		name: "Cobblemon Triples",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "triples"
	},
	{
		name: "Cobblemon Rotation",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "rotation"
	},
	{
		name: "Cobblemon Multi",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "multi"
	},
	{
		name: "Cobblemon Free for All",
		threads: [],

		mod: 'cobblemon',
		ruleset: [],
		gameType: "freeforall"
	},
];
